import React, { useEffect, useRef, useState } from 'react';

let mapsLoaderPromise = null;

function loadMaps(apiKey) {
  if (mapsLoaderPromise) return mapsLoaderPromise;
  mapsLoaderPromise = new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.google.maps);
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return mapsLoaderPromise;
}

function MapPicker({ apiKey, value, onChange }) {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!apiKey) {
      setError('Google Maps API key missing.');
      return undefined;
    }

    let mapInstance;
    let listener;

    loadMaps(apiKey)
      .then((maps) => {
        const center = value && value.lat && value.lng
          ? { lat: value.lat, lng: value.lng }
          : { lat: 18.1096, lng: -77.2975 }; // Jamaica
        mapInstance = new maps.Map(mapRef.current, {
          center,
          zoom: value ? 12 : 7,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        });

        if (value && value.lat && value.lng) {
          markerRef.current = new maps.Marker({ position: center, map: mapInstance });
        }

        listener = mapInstance.addListener('click', (e) => {
          const pos = { lat: e.latLng.lat(), lng: e.latLng.lng() };
          if (markerRef.current) {
            markerRef.current.setPosition(pos);
          } else {
            markerRef.current = new maps.Marker({ position: pos, map: mapInstance });
          }
          if (onChange) onChange(pos);
        });
      })
      .catch(() => setError('Failed to load map.'));

    return () => {
      if (listener) listener.remove();
    };
  }, [apiKey, onChange, value]);

  return (
    <div style={{ width: '100%' }}>
      {error && <div style={{ color: '#c0392b', marginBottom: '0.5rem' }}>{error}</div>}
      <div
        ref={mapRef}
        style={{ width: '100%', height: '260px', borderRadius: '10px', border: '1px solid #0b9e6a', overflow: 'hidden' }}
      />
      {value && value.lat && value.lng && (
        <div style={{ marginTop: '0.4rem', fontSize: '0.95rem', color: '#007b5e' }}>
          Selected: {value.lat.toFixed(5)}, {value.lng.toFixed(5)}
        </div>
      )}
    </div>
  );
}

export default MapPicker;
